import { render, staticRenderFns } from "./userConservationDetails.vue?vue&type=template&id=7e857207&scoped=true"
import script from "./userConservationDetails.vue?vue&type=script&lang=js"
export * from "./userConservationDetails.vue?vue&type=script&lang=js"
import style0 from "./userConservationDetails.vue?vue&type=style&index=0&id=7e857207&prod&lang=scss&scoped=true"
import style1 from "./userConservationDetails.vue?vue&type=style&index=1&id=7e857207&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e857207",
  null
  
)

export default component.exports